import { buildPage } from 'page-builders/CategoryPage';

import FetchError from 'utils/fetch-error';
import { getContentPageRevalidationTime } from 'utils/config';

import { GraphQLClient } from 'graphql-request';

import {
  CollectionPageDocument,
  CollectionPagePathsDocument,
  type ContentProperty,
} from 'queries/graphql';

import { buildContentPropertyProps, buildContentPropFooterLinks } from 'utils/article-helpers';

export async function getStaticProps(context) {
  const endpoint = process.env.HASURA_ENDPOINT;
  const gqlClient = new GraphQLClient(endpoint, {
    headers: {
      'x-hasura-admin-secret': process.env.HASURA_GRAPHQL_ADMIN_SECRET,
    },
  });

  try {
    const { params, preview = null } = context;
    const { propertyId, category, collection } = params;

    const propertyQuery = await gqlClient.request(CollectionPageDocument, {
      propertyId,
      category,
      collection,
    });

    // @ts-ignore - The sales page object is every field in the sales page query, we don't actually need every field. Would be nice to just get the sales page object Type from the query...
    const contentProperty: ContentProperty = propertyQuery.contentProperty?.[0];
    const contentPropertyProps = buildContentPropertyProps(contentProperty);
    const links = buildContentPropFooterLinks(contentProperty);

    const selectedCateogry = contentProperty.categories.find(c => c.slug === category);
    const selectedCollection = selectedCateogry?.collections.find(c => c.slug === collection);

    return {
      revalidate: getContentPageRevalidationTime(),
      props: {
        preview,
        contentProperty,
        contentPropertyProps,
        links,
        category: selectedCateogry,
        collection: selectedCollection,
      },
    };
  } catch (err) {
    if (err instanceof FetchError) {
      const { statusCode } = err;
      switch (statusCode) {
        case 404: {
          return {
            redirect: {
              destination: '/',
              permanent: false,
            },
          };
        }

        default: {
          throw err;
        }
      }
    }

    throw err;
  }
}

export async function getStaticPaths() {
  const endpoint = process.env.HASURA_ENDPOINT;
  const gqlClient = new GraphQLClient(endpoint, {
    headers: {
      'x-hasura-admin-secret': process.env.HASURA_GRAPHQL_ADMIN_SECRET,
    },
  });

  const pagePathsQuery: any = await gqlClient.request(CollectionPagePathsDocument);

  const properties = pagePathsQuery.contentProperty as ContentProperty[];

  const paths = properties.flatMap(({ id, categories }) => {
    const propertyId = id.toString();

    return categories.flatMap(({ slug: category, collections }) => {
      return collections.flatMap(({ slug: collection }) => ({
        params: {
          propertyId,
          category,
          collection,
        },
      }));
    });
  });

  return { paths, fallback: 'blocking' };
}

export default buildPage();
